import React from 'react'
import { Button, Upload } from 'antd'
import './style.scss'


export default ({ btnList, btnStyle }) => {
  return (
    <div style={{ ...btnStyle, }}>
      {
        btnList.map(item => {
          if (item.type === 'upload') {
            return <Upload key={item.title}
              {...item.props}
            >
              {
                <div className="upload-clk-area">
                  <Button icon={item.icon} type='primary' style={{ ...item.style, }}>{item.title}</Button>
                </div>
              }
            </Upload>

          } else {
            if ( item.visible ) {
              return (
                <Button
                  key={item.title}
                  style={{ ...item.style,marginLeft: 20 }}
                  onClick={item.onClick}
                  size={item.size || "default"}
                  icon={item.icon}
                  type={item.type || "default"}>{item.title}
                </Button>
              )
            }
          }
        })
      }
    </div>
  )
}
